import './modal-window.scss'

/**
 *  Component Definition
 *
 * @export
 * @class ModalWindow
 * @implements {ng.IComponentOptions}
 */
export class ModalWindow implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: ng.IControllerConstructor = ModalWindowController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./modal-window.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {
  }
}

/**
 * ModalWindow - Controller
 *
 * @export
 * @class ModalWindowController
 */
export class ModalWindowController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'ModalManager', 'AppServices', 'ProgressManager', 'TrackingManager', '$animate', 'UserAgentManager']
  public browserVersion: any;
  public isIos: any;
  public displayCopyButton: boolean = true;

  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public ModalManager: any, public AppServices: any, public ProgressManager: any, public TrackingManager: any, public $animate: any, public UserAgentManager: any) {
    this.$log = $log.getInstance('ModalWindow', false);
    this.$log.debug('constructor')
  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')
    let clipboard = new Clipboard('.copy-url-button');
    clipboard.on('success', (e) => {
        $('.copy-url-button').addClass('copied').find('p').html(this.AppServices.DataManager.langContent.SHARE_MODAL_COPIED_BUTTON.value)
        e.clearSelection();
    });
    this.browserVersion = this.UserAgentManager.getBrowserVersion();
    this.isIos = this.UserAgentManager.isIOS();
    if (this.browserVersion <= 9 && this.isIos){
      this.displayCopyButton = false;
    }
  }

  public onReset(options){
    this.$log.debug('onRestart')
    this.TrackingManager.trackRestart();
    let selectedGender = this.AppServices.HeroManager.selectedGender;
    if (selectedGender == ''){
      selectedGender = this.ProgressManager.getGender();
    }
    if (!this.AppServices.ScreenManager.displayBackgrounds) {
      this.AppServices.ScreenManager.switchCarousel();
    }
    this.AppServices.ColorManager.resetColors();
    localStorage.removeItem('heromaker.PROGRESS_STICKERS_GOTG');
    localStorage.removeItem('heromaker.PROGRESS_COVER_BG_GOTG');
    this.AppServices.HeroManager.setGender(selectedGender);
    this.AppServices.ScreenManager.navDisabled = false
    //this.ProgressManager.reset();
    this.AppServices.PixiManager.resetPixi();
    let printImage = document.querySelector('.print-screen__cover')
    if (printImage){
      printImage.parentElement.removeChild(printImage)
    }
    this.AppServices.ScreenManager.performNavigation('jumpToStart', options);
    this.ModalManager.dismiss();
  }

  public dismiss() {
    this.$log.debug('hide')
    $('.copy-url-button').removeClass('copied').find('p').html(this.AppServices.DataManager.langContent.SHARE_MODAL_COPY_BUTTON.value)
    this.ModalManager.isActive = false;
  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges', changesObj)
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/common/components/modal-window/modal-window.ts
 **/